import { API } from 'aws-amplify';
import isEmpty from 'lodash/isEmpty';

import { authHeader } from 'utils/auth';
import {
  createEstablishment as CreateEstablishment,
  updateEstablishment as UpdateEstablishment
} from 'graphql/mutations';
import {
  Establishment,
  CreateEstablishmentMutation,
  UpdateEstablishmentMutation
} from 'graphql-api';
import { GraphQLResult } from '@aws-amplify/api';
import { EstablishmentDataInterface } from 'types/establishment';

export async function saveEstablishment(
  establishmentData: EstablishmentDataInterface
): Promise<Establishment | null> {
  if (!isEmpty(establishmentData.id)) {
    const responseData = (await API.graphql({
      query: UpdateEstablishment,
      variables: { input: establishmentData },
      authMode: 'AMAZON_COGNITO_USER_POOLS'
    })) as GraphQLResult<UpdateEstablishmentMutation>;
    return responseData.data?.updateEstablishment ?? null;
  } else {
    const responseData = (await API.graphql({
      query: CreateEstablishment,
      variables: { input: establishmentData },
      authMode: 'AMAZON_COGNITO_USER_POOLS'
    })) as GraphQLResult<CreateEstablishmentMutation>;
    return responseData.data?.createEstablishment ?? null;
  }
}

export async function getEstablishments(reportId: string): Promise<Object[]> {
  const apiName = 'establishmentAPI';
  const path = `/report/${reportId}/establishments`;
  const headers = await authHeader();
  try {
    return await API.get(apiName, path, {
      headers
    });
  } catch (error) {
    console.log('Error: ', error);
    return [];
  }
}
